module.exports = { src: __webpack_public_path__ + "media/tile-2-overlay.ccd698a6.webp", width: 365, height: 400 };